import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'redux';
import {graphql} from 'react-apollo';
import map from 'lodash.map';
import every from 'lodash.every';

import Page from 'components/Page';
import Button, {ModalXButton} from 'components/Button';
import Footer from 'components/Footer';
import Spinner from 'components/Spinner';

import {
  closedQuery as query
} from 'flows/deal/status';

import './style.css';

/* eslint-disable max-len */
export const DealClosedConfirmation = ({sending, cancel, submit, data: { loading, deal }}) => {
  if (sending || loading) {
    return (
      <Page>
        <Spinner />
      </Page>
    );
  }

  const allSigned = every(map(deal.allocations, 'documents.signed'));

  return (
    <Page>
      <header styleName="header toplevel">
        <h2 styleName="h2">What happens now?</h2>
        <ModalXButton onClick={cancel} data-test="closed_cancel" />
      </header>
      <section styleName="content">
        <p>
          Once all you investors have signed their closing documents, you can close the deal.
        </p>
        <p>When you move onto the next phase:</p>
        <ul>
          <li>Investors will be sent their <strong>contracts</strong> counter-signed by you.</li>
        </ul>
        {!allSigned && (
          <p styleName="error">
            All investors must sign their closing docs before you can close this deal
          </p>
        )}
      </section>
      <Footer styleName="toplevel">
        <Button onClick={submit} data-test="closed_submit" disabled={!allSigned}>
          Close Deal
        </Button>
      </Footer>
    </Page>
  );
};
/* eslint-enable max-len */

DealClosedConfirmation.propTypes = {
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    deal: PropTypes.object,
  }).isRequired,
};


const mapPropsToOptions = ({deal}) => ({
  variables: {dealId: deal.id}
});

export default compose(
  graphql(query, {
    options: mapPropsToOptions,
  })
)(DealClosedConfirmation)



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealClosedConfirmation/component.js